import { z } from 'zod';
export var BudgetLocale;
(function (BudgetLocale) {
    BudgetLocale["CS_CZ"] = "CS_CZ";
    BudgetLocale["DE_AT"] = "DE_AT";
    BudgetLocale["DE_DE"] = "DE_DE";
    BudgetLocale["EN_AU"] = "EN_AU";
    BudgetLocale["EN_CA"] = "EN_CA";
    BudgetLocale["EN_GB"] = "EN_GB";
    BudgetLocale["EN_HK"] = "EN_HK";
    BudgetLocale["EN_KE"] = "EN_KE";
    BudgetLocale["EN_US"] = "EN_US";
    BudgetLocale["ES_AR"] = "ES_AR";
    BudgetLocale["ES_ES"] = "ES_ES";
    BudgetLocale["FR_FR"] = "FR_FR";
    BudgetLocale["JA_JP"] = "JA_JP";
    BudgetLocale["NB_NO"] = "NB_NO";
    BudgetLocale["PL_PL"] = "PL_PL";
    BudgetLocale["PT_BR"] = "PT_BR";
    BudgetLocale["RU_RU"] = "RU_RU";
    BudgetLocale["ZH_HK"] = "ZH_HK";
})(BudgetLocale || (BudgetLocale = {}));
// Locale-based delimiter/separator mappings
export const LOCALE_FORMATS = {
    [BudgetLocale.CS_CZ]: { delimiter: '_', separator: ',' },
    [BudgetLocale.DE_AT]: { delimiter: '.', separator: ',' },
    [BudgetLocale.DE_DE]: { delimiter: '.', separator: ',' },
    [BudgetLocale.EN_AU]: { delimiter: ',', separator: '.' },
    [BudgetLocale.EN_CA]: { delimiter: ',', separator: '.' },
    [BudgetLocale.EN_GB]: { delimiter: ',', separator: '.' },
    [BudgetLocale.EN_HK]: { delimiter: ',', separator: '.' },
    [BudgetLocale.EN_KE]: { delimiter: ',', separator: '.' },
    [BudgetLocale.EN_US]: { delimiter: ',', separator: '.' },
    [BudgetLocale.ES_AR]: { delimiter: '.', separator: ',' },
    [BudgetLocale.ES_ES]: { delimiter: '.', separator: ',' },
    [BudgetLocale.FR_FR]: { delimiter: ' ', separator: ',' },
    [BudgetLocale.JA_JP]: { delimiter: ',', separator: '.' },
    [BudgetLocale.NB_NO]: { delimiter: '_', separator: ',' },
    [BudgetLocale.PL_PL]: { delimiter: ' ', separator: ',' },
    [BudgetLocale.PT_BR]: { delimiter: '.', separator: ',' },
    [BudgetLocale.RU_RU]: { delimiter: ' ', separator: ',' },
    [BudgetLocale.ZH_HK]: { delimiter: ',', separator: '.' },
};
// Locale display names
export const LOCALE_NAMES = {
    [BudgetLocale.CS_CZ]: 'Czech - Czech Republic',
    [BudgetLocale.DE_AT]: 'German - Austria',
    [BudgetLocale.DE_DE]: 'German - Germany',
    [BudgetLocale.EN_AU]: 'English - Australia',
    [BudgetLocale.EN_CA]: 'English - Canada',
    [BudgetLocale.EN_GB]: 'English - United Kingdom',
    [BudgetLocale.EN_HK]: 'English - Hong Kong',
    [BudgetLocale.EN_KE]: 'English - Kenya',
    [BudgetLocale.EN_US]: 'English - United States',
    [BudgetLocale.ES_AR]: 'Spanish - Argentina',
    [BudgetLocale.ES_ES]: 'Spanish - Spain',
    [BudgetLocale.FR_FR]: 'French - France',
    [BudgetLocale.JA_JP]: 'Japanese - Japan',
    [BudgetLocale.NB_NO]: 'Norwegian - Norway',
    [BudgetLocale.PL_PL]: 'Polish - Poland',
    [BudgetLocale.PT_BR]: 'Portuguese - Brazil',
    [BudgetLocale.RU_RU]: 'Russian - Russia',
    [BudgetLocale.ZH_HK]: 'Chinese - Hong Kong',
};
export const budgetLocaleSchema = z.nativeEnum(BudgetLocale);
export const budgetLocaleSelectOptions = Object.entries(LOCALE_NAMES)
    .map(([value, label]) => ({
    value: value,
    label,
}))
    .sort((a, b) => a.label.localeCompare(b.label));
